/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
// COMPONENTS
import _ from "underscore";
import CheckoutCartButton from "../../../components/CheckoutCartButton/CheckoutCartButton";
import QuickCheckoutButton from "../../../components/QuickCheckoutButton/QuickCheckoutButton";
import DiscountTag from "../../../components/DiscountTag/DiscountTag";
// Redux
import * as userActions from "../../../redux/actions/user";
import * as elementActions from "../../../redux/actions/elements";
import styles from "./SingleProduct.module.css";
import DeliveryPickUpWidget from "../../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import Loader from "../../../components/Loader/Loader";
import BrandRefreshButtonSpinner from "../../../components/BrandRefreshButtonSpinner/BrandRefreshButtonSpinner";

import { orderTypeIds, orderMethods } from "../../../shared/constants/order";
import { shippingMethods, storeIds } from "../../../shared/constants/store";
import endpoints from "../../../shared/constants/endpoints";
import { historyAction } from "../../../shared/constants/history";
import * as orderRepo from "../../../shared/repos/graphql/order";
import * as productConstants from "../../../shared/constants/product";
import * as productRepo from "../../../shared/repos/graphql/product";

import * as tagmanagerEvents from "../../../shared/utilities/tagmanagerEvents";
import amplitudeAnalytics, {
  AMPLITUDE_NAV_SECTION_SECONDARY,
  formatAmplitudeSuggestedItemCategory,
  getAmplitudeSuggestedItemPageNameForPdp,
} from "../../../shared/utilities/amplitude";
import {
  getErrorMessages,
  getErrorReasons,
  routeCountryPath
} from "../../../shared/utilities/common";
import errorCodes from "../../../shared/constants/errorCodes";
import { handleProductWithDirectLink } from "../../../shared/utilities/product";
import { requestProductFulfillment } from "../../../shared/utilities/productFulfillment";
import {
  isDeliveryOrPickup,
  clearCart
} from "../../../shared/utilities/orders";
import { defaultCurrency } from "../../../shared/constants/currency";

import { openOrderUpdateFailModal } from "../../../shared/utilities/modals";
import * as loyaltyAction from "../../../redux/actions/loyalty";
import { store } from "../../../redux/store";
import { calculateLoyaltyPoints } from "../../../shared/utilities/loyalty";
import { PUNCHH_TYPE } from "../../../shared/constants/loyaltyType";
import { renderLoyaltyPrice } from "../../../shared/utilities/renderings";
import { getCartErrorMessage } from "../../../shared/utilities/cart";
import { isBrandRefreshEnabled } from "../../../shared/utilities/brandRefresh";
import brStyles from "./SingleProductBrandRefresh.module.css";

const addIcon = require("../imgs/plus.svg");
const minusIcon = require("../imgs/minus.svg");
const darkAddIcon = require("../imgs/dark-plus.svg");
const darkMinusIcon = require("../imgs/dark-minus.svg");
const backIcon = require("../imgs/back-icon.svg");
const lightBackIcon = require("../imgs/light-back-icon.svg");
const brBackIcon = require("./images/back-chevron-brand-refresh.svg");
const brMinusIcon = require("./images/qty-minus-brand-refresh.svg");
const brPlusIcon = require("./images/qty-plus-brand-refresh.svg");

class SingleProduct extends Component {
  constructor(props) {
    super(props);
    const { history } = this.props;
    this.state = {
      productPrice: 0.0,
      quantity: null,
      updateCartLoading: false,
      updatePriceLoading: false,
      productAddError: "",
      locationKey: history.location.key,
      points: 0
    };
  }

  componentDidMount() {
    this.setProductData()
      .then(() => {
        handleProductWithDirectLink(this);
        // eslint-disable-next-line no-unused-vars
      })
      .catch(() => {});
    if (typeof window !== "undefined" && window.requestAnimationFrame) {
      window.requestAnimationFrame(() => this.syncBrandRefreshHeaderClearance());
    } else {
      this.syncBrandRefreshHeaderClearance();
    }
  }

  async componentDidUpdate(prevProps) {
    const { selectedStore, history, location } = this.props;
    const { locationKey } = this.state;

    if (selectedStore && selectedStore !== prevProps.selectedStore) {
      await this.setProductData();
    }
    if (history.action === historyAction.pop && location.key !== locationKey) {
      history.goBack();
    }
    this.syncBrandRefreshHeaderClearance();
  }

  componentWillUnmount() {
    this.teardownBrandRefreshHeaderClearance();
  }

  syncBrandRefreshHeaderClearance = () => {
    if (!isBrandRefreshEnabled()) {
      return;
    }

    const applyClearance = () => {
      const wrapper = document.querySelector(
        '[data-region="single-product-pdp"]'
      );
      const header = document.querySelector('header[role="banner"]');
      if (!wrapper) {
        return;
      }
      if (!header) {
        wrapper.style.setProperty("--sp-header-clearance", "0px");
        return;
      }
      const headerBottom = header.getBoundingClientRect().bottom;
      const bodyPad =
        parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
      const shortfall = Math.max(0, Math.round(headerBottom - bodyPad));
      wrapper.style.setProperty("--sp-header-clearance", `${shortfall}px`);
    };

    applyClearance();

    if (
      typeof ResizeObserver !== "undefined" &&
      !this.brandRefreshHeaderObserver
    ) {
      const header = document.querySelector('header[role="banner"]');
      if (header) {
        this.brandRefreshHeaderObserver = new ResizeObserver(applyClearance);
        this.brandRefreshHeaderObserver.observe(header);
      }
    }
  };

  teardownBrandRefreshHeaderClearance = () => {
    if (this.brandRefreshHeaderObserver) {
      this.brandRefreshHeaderObserver.disconnect();
      this.brandRefreshHeaderObserver = null;
    }
  };

  setProductData = async () => {
    const { match, userCart, loyalty, redeemables, isShowOosProducts, productId } = this.props;
    const { quantity } = this.state;

    const { params } = match;
    const { poid } = params;
    const selectedItem = userCart.find(item => item.id === poid);
    this.setState({
      updatePriceLoading: true,
      updateCartLoading: true,
      item: selectedItem
    });
    const id = productId ?? params.id;
    const redeemableId = redeemables?.redeemableId ? redeemables?.redeemableId : null;
    const { data } = await productRepo.getProduct(id, redeemableId, isShowOosProducts);
    const { product } = data;
    if (!quantity) {
      this.setState({
        quantity: selectedItem ? selectedItem.quantity : 1
      });
    }

    this.setState({
      product,
      productPrice: product.price,
      updatePriceLoading: false,
      updateCartLoading: false
    });

    if (loyalty) {
      this.getProductLoyaltyPoints(loyalty, id, poid);
    }
  };

  getProductLoyaltyPoints = (loyalty, id, poid) => {
    const {order, loyaltyPoints, loyaltyDeals, loyaltyRedeemables, history} = this.props;
    const loyaltyProducts = loyalty === PUNCHH_TYPE.REDEEMABLE ? loyaltyRedeemables : loyaltyDeals
    try {
      const points = calculateLoyaltyPoints(
        loyalty,
        id,
        poid,
        loyaltyPoints,
        loyaltyProducts,
        order
      );
      this.setState({
        points
      })
    } catch (error) {
      history.push(endpoints.loyalty);
    }
  }

  /**
   * Handles quantity state setting
   * @param {boolean} increase - boolean argument to handle increase/decrease
   */
  handleQuantityChange = increase => {
    const { quantity } = this.state;
    // if decreasing and quantity is at 0, do nothing more
    if (!increase && quantity === 1) return;
    // otherwise increase or decrease state
    this.setState({ quantity: increase ? quantity + 1 : quantity - 1 });
  };

  handleProductUpdate = async () => {
    const {
      userCartId,
      history,
      setUserCart,
      loyalty,
      redeemables,
    } = this.props;
    const { item, product, quantity } = this.state;

    if (product?.title != null && product?.id != null) {
      amplitudeAnalytics.trackUpdateItem({
        productName: product.title,
        productId: product.id,
      });
    }

    let res;
    try {
      res = await orderRepo.addUpdateOrderProduct(userCartId, {
        orderProductId: parseInt(item.id, 10),
        product: product.id,
        price: product.price,
        quantity,
        redeemableId: loyalty === "redeem" ? redeemables?.redeemableId : null,
        dealId: loyalty === "deals" ? redeemables?.redeemableId : null
      });
    } catch (reason) {
      this.setState({
        updateCartLoading: false,
        productAddError: getCartErrorMessage(reason)
      });

      return;
    }
    

    tagmanagerEvents.addToCart({
      ...product,
      quantity,
      price: (product.price * quantity).toFixed(2)
    });

    const order = res.data.updateProductOrder;

    const localStorageCart = order.items.map(item1 => item1);
    setUserCart(localStorageCart);

    history.push(routeCountryPath(`/checkout/view-order/`));
  };

  handleAddItemToOrder = async (orderCode, quickCheckout = false, fulfillment) => {
    const {
      setUserCart,
      history,
      userOrderMethod,
      loyalty,
      loyaltyPoints,
      redeemables,
      location,
      currency
    } = this.props;
    const { product, quantity, points } = this.state;

    // Assign cake topper image ID to specific it's product

    if (quickCheckout) {
      tagmanagerEvents.clickQuickCheckout({
        ...product,
        quantity,
        price: (product.price * quantity).toFixed(2)
      });
    } else {
      tagmanagerEvents.addToCart({
        ...product,
        quantity,
        price: (product.price * quantity).toFixed(2)
      });
    }

    let result;
    try {
      result = await orderRepo.addProductToOrder(
        orderCode,
        {
          product: product.id,
          quantity,
          redeemableId: loyalty === "redeem" ? redeemables?.redeemableId : null,
          dealId: loyalty === "deals" ? redeemables?.redeemableId : null,
        },
        {
          pathname: location?.pathname,
          source: 'single_product',
          currencySymbol: currency?.symbol || '$',
        },
      );

      if ( loyalty ) {
        store.dispatch(loyaltyAction.loyaltyPoints(loyaltyPoints - points));
      }
    } catch (reason) {
      this.setState({
        updateCartLoading: false,
        productAddError: getCartErrorMessage(reason)
      });

      return;
    }

    const localStorageCart = result.data.addProductToOrderV2.items.map(
            (itemIn) => itemIn
    );
    setUserCart(localStorageCart);

    const cartSuggestedPage = getAmplitudeSuggestedItemPageNameForPdp(
      location?.pathname,
      location?.search
    );
    if (cartSuggestedPage) {
      amplitudeAnalytics.trackAddSuggestedItem({
        pageName: cartSuggestedPage,
        productCategory: formatAmplitudeSuggestedItemCategory(product.categories),
        productName: product.title,
        productId: product.id,
      });
    }

    if (quickCheckout) {
      return result;
    }

    const addLink =
      (fulfillment || userOrderMethod) === orderMethods.shipping
        ? endpoints.shippingPage
        : endpoints.menu;
    history.push(routeCountryPath(addLink));
  };

  setCartStates = () => {
    const { history } = this.props;

    clearCart();
    history.push(routeCountryPath(endpoints.getMenuUrl(null)));
  };

  handleCartCreateError = reason => {
    const { setModalObject } = this.props;
    const message = getErrorMessages(reason, 0);
    const reasonType = getErrorReasons(reason, 0);
    const createReason = reasonType === errorCodes.CART_CREATE_ERROR;
    if (createReason) {
      setModalObject(openOrderUpdateFailModal(message, this.setCartStates));
    }
  };

  handleShipping = async () => {
    const { userCartId, setUserCartId } = this.props;

    if (userCartId) {
      return this.handleAddItemToOrder(userCartId);
    }

    const data = {
      orderTypeId: orderTypeIds.shipping,
      shippingMethod: shippingMethods.shipping,
      storeId: storeIds.shipping
    };

    try {
      const res = await orderRepo.createCart(data);

      const { createCart } = res.data;

      setUserCartId(createCart.code);

      return this.handleAddItemToOrder(createCart.id);
    } catch (reason) {
      this.handleCartCreateError(reason);
    }
  };

  handlePickupDelivery = async (quickCheckout = false) => {
    const {
      userCartId,
      selectedStore,
      userOrderMethod,
      setUserCartId
    } = this.props;

    if (selectedStore) {
      if (!userCartId) {
        let orderTypeId = null;
        let shippingMethod = null;
        if (userOrderMethod === orderMethods.delivery) {
          orderTypeId = 2;
          shippingMethod = 4;
        } else if (userOrderMethod === orderMethods.pickup) {
          orderTypeId = 3;
          shippingMethod = 3;
        }
        let storeId = null;
        if (selectedStore && selectedStore.id) {
          storeId = selectedStore.id;
        }

        const data = {
          orderTypeId,
          shippingMethod,
          storeId
        };

        try {
          const res = await orderRepo.createCart(data);
          const { createCart } = res.data;
          setUserCartId(createCart.code);
          return this.handleAddItemToOrder(createCart.code, quickCheckout);
        } catch (reason) {
          this.handleCartCreateError(reason);
        }
      }

      return this.handleAddItemToOrder(userCartId, quickCheckout);
    }

    this.setState({ updateCartLoading: false });
    return true;
  };

  handleAddItem = () => {
    const {
      userOrderMethod,
      setModalObject,
      updateProduct,
      loyaltyPoints
    } = this.props;
    const { points, product } = this.state;
    if (product.oos === 1) {
      return;
    }
    if (requestProductFulfillment(this, code =>
      this.handleAddItemToOrder(code, false, orderMethods.shipping)
    )) return;
    this.setState({ updateCartLoading: true, productAddError: '' });

    store.dispatch(loyaltyAction.loyaltyPoints(loyaltyPoints - points));

    if (updateProduct) {
      return this.handleProductUpdate();
    }

    if (userOrderMethod === orderMethods.shipping) {
      return this.handleShipping();
    }

    if (isDeliveryOrPickup(userOrderMethod)) {
      return this.handlePickupDelivery();
    }
    return setModalObject({
      fullscreenChildren: true,
      children: (
        <DeliveryPickUpWidget
          isModal
          productId={product?.id}
          analyticsPageSection="Product Image"
        />
      )
    });
  };

  handleQuickCheckout = async () => {
    const { product } = this.state;
    if (product.oos === 1) {
      return;
    }
    if (requestProductFulfillment(this, code =>
      this.handleAddItemToOrder(code, false, orderMethods.shipping)
    )) return;
    const { userOrderMethod, userCart, userCartId } = this.props;

    this.setCartLoading(true);

    if (isDeliveryOrPickup(userOrderMethod)) {
      const orderProductIds = _.pluck(userCart, "id");
      if (orderProductIds.length) {
        await orderRepo.removeProducts(userCartId, orderProductIds);
      }

      const [res] = await Promise.all([this.handlePickupDelivery(true)]);

      const { addProductToOrderV2 } = res.data;
      return { addProductToOrderV2 };
    }
  };

  setCartLoading = value => {
    this.setState({ updateCartLoading: value });
  };

  handleBackToMenu = () => {
    const { history, location, selectedStore } = this.props;
    const isShippingStore =
      selectedStore && selectedStore.id === storeIds.shipping;

    amplitudeAnalytics.trackClickNavSecondary({
      navElement: "Back to Menu",
      navSection: AMPLITUDE_NAV_SECTION_SECONDARY.PRODUCT_PAGE,
      pathname: location?.pathname,
    });
    history.push(
      routeCountryPath(
        isShippingStore
          ? endpoints.shippingPage
          : endpoints.getMenuUrl(selectedStore)
      )
    );
  };

  getSingleProductViewModel = () => {
    const {
      updateProduct,
      selectedStore,
      isCaloriesActive,
      currency,
      loyalty,
    } = this.props;
    const {
      product,
      quantity,
      updateCartLoading,
      productAddError,
      productPrice,
      updatePriceLoading,
      points,
    } = this.state;

    if (!product) {
      return null;
    }

    const addProductText = selectedStore
      ? productConstants.ADD_TO_ORDER_TEXT
      : productConstants.ADD_TO_ORDER_NO_ADDRESS_TEXT;
    const addUpdateProductText = updateProduct
      ? productConstants.UPDATE_PRODUCT_TEXT
      : addProductText;
    const outOfStockText = productConstants.OUT_OF_STOCK_TEXT;
    const canShowUnitPrice =
      !updatePriceLoading &&
      typeof productPrice === 'number' &&
      (isBrandRefreshEnabled() || Boolean(selectedStore));
    const productPriceItem = canShowUnitPrice
      ? `${currency.symbol}${productPrice.toFixed(2)}`
      : null;
    const totalCost =
      selectedStore && !updatePriceLoading
        ? (productPrice * quantity).toFixed(2)
        : null;
    const calories =
      isCaloriesActive && product.calories != null
        ? ` ${product.calories} kCal`
        : "";
    const ctaLabel = product.oos === 1 ? outOfStockText : addUpdateProductText;
    let ctaButtonText = ctaLabel;
    if (product.oos !== 1) {
      if (loyalty && points != null) {
        ctaButtonText = `${ctaLabel} · ${points} pts`;
      } else if (totalCost != null) {
        ctaButtonText = `${ctaLabel} · ${currency.symbol}${totalCost}`;
      }
    }

    return {
      product,
      quantity,
      updateCartLoading,
      productAddError,
      points,
      productPriceItem,
      totalCost,
      calories,
      ctaLabel,
      ctaButtonText,
      showQtyControls: !(loyalty || product.oos === 1),
      showCashPrice: !loyalty,
    };
  };

  openAddressSelectionModal = () => {
    const { setModalObject } = this.props;
    const { product } = this.state;
    setModalObject({
      fullscreenChildren: true,
      children: (
        <DeliveryPickUpWidget
          isModal
          productId={product?.id}
          analyticsPageSection="Product Image"
        />
      )
    });
  };

  handleBrandRefreshAddItem = () => {
    const { userOrderMethod, selectedStore } = this.props;
    const { product } = this.state;
    if (product?.oos === 1) {
      return;
    }
    if (requestProductFulfillment(this, code =>
      this.handleAddItemToOrder(code, false, orderMethods.shipping)
    )) return;

    if (userOrderMethod === orderMethods.shipping) {
      return this.handleAddItem();
    }

    const needsStore =
      isDeliveryOrPickup(userOrderMethod) ||
      userOrderMethod === orderMethods.eGiftCard;

    if (needsStore && selectedStore) {
      return this.handleAddItem();
    }

    if (needsStore && !selectedStore) {
      return this.openAddressSelectionModal();
    }

    // No order method (or unknown) — same as CheckoutCartButton fallback.
    return this.openAddressSelectionModal();
  };

  brandRefreshContainer = () => {
    const viewModel = this.getSingleProductViewModel();
    if (!viewModel) {
      return (
        <div className={brStyles.pageWrapper}>
          <div data-part="page-loader">
            <Loader />
          </div>
        </div>
      );
    }

    const {
      product,
      quantity,
      updateCartLoading,
      productAddError,
      productPriceItem,
      points,
      calories,
      ctaButtonText,
      showQtyControls,
      showCashPrice,
    } = viewModel;
    const { currency, loyalty } = this.props;

    const renderAddButton = () => (
      <button
        type="button"
        data-part="add-btn"
        data-loading={updateCartLoading ? "true" : undefined}
        aria-busy={updateCartLoading ? "true" : undefined}
        disabled={product.oos === 1 || updateCartLoading}
        onClick={() => this.handleBrandRefreshAddItem()}
      >
        {updateCartLoading ? (
          <BrandRefreshButtonSpinner />
        ) : (
          <span data-part="add-btn-label">{ctaButtonText}</span>
        )}
      </button>
    );

    return (
      <div
        className={brStyles.pageWrapper}
        data-region="single-product-pdp"
      >
        <div data-part="pdp-inner">
          <div data-part="photo-card">
            <img alt={product.title || ""} src={product.productImage} />
          </div>

          <div data-part="info-card">
            <button
              type="button"
              data-part="back-link"
              onClick={this.handleBackToMenu}
            >
              <img
                alt=""
                src={brBackIcon}
                data-part="back-icon"
                aria-hidden="true"
              />
              Back to Menu
            </button>

            <div data-part="product-details">
              {product.discountPercent > 0 ? (
                <DiscountTag
                  discountPercent={product.discountPercent}
                  isBrandRefresh
                />
              ) : null}
              <div data-part="title-row">
                <h1 data-part="product-title">
                  {product.metaHeading || product.title}
                </h1>

                {loyalty ? (
                  <div data-part="price-row">
                    <span data-part="loyalty-points">
                      {points}
                      {' pts'}
                    </span>
                  </div>
                ) : showCashPrice && productPriceItem ? (
                  <div data-part="price-row">
                    {product.strike_price ? (
                      <>
                        <span data-part="price-strike">
                          {currency.symbol}
                          {parseFloat(product.strike_price).toFixed(2)}
                        </span>
                        <span>{productPriceItem}</span>
                      </>
                    ) : (
                      <span>{productPriceItem}</span>
                    )}
                  </div>
                ) : null}
              </div>

              <div data-part="product-copy">
                <p data-part="product-description">
                  {product.description}
                  {calories}
                </p>
                <a
                  data-part="nutrition-link"
                  href={
                    product.nutritionInfoLink
                      ? product.nutritionInfoLink
                      : endpoints.nutritionalInfo
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Nutritional info
                </a>
              </div>

              {showQtyControls ? (
                <div data-part="qty-row">
                  <div data-part="qty-labels">
                    <p data-part="qty-label">How many?</p>
                    <button
                      type="button"
                      data-part="clear-link"
                      onClick={() => this.setState({ quantity: 1 })}
                    >
                      Clear selections
                    </button>
                  </div>
                  <div data-part="qty-control">
                    <button
                      type="button"
                      data-part="qty-btn"
                      aria-label="Decrease quantity"
                      disabled={quantity <= 1}
                      onClick={() => this.handleQuantityChange()}
                    >
                      <img alt="" src={brMinusIcon} aria-hidden="true" />
                    </button>
                    <span data-part="qty-value">{quantity}</span>
                    <button
                      type="button"
                      data-part="qty-btn"
                      aria-label="Increase quantity"
                      onClick={() => this.handleQuantityChange(true)}
                    >
                      <img alt="" src={brPlusIcon} aria-hidden="true" />
                    </button>
                  </div>
                </div>
              ) : null}
            </div>

            <div data-part="actions">
              {renderAddButton()}
              {productAddError.length ? (
                <p data-part="error-message">{productAddError}</p>
              ) : null}
            </div>
          </div>
        </div>

        {/* Mobile only: sticky Add to Order (in-card actions hidden ≤767px) */}
        <div data-part="sticky-actions">
          {renderAddButton()}
          {productAddError.length ? (
            <p data-part="error-message">{productAddError}</p>
          ) : null}
        </div>
      </div>
    );
  };

  /**
   * Renders Single Product Container
   */
  singleProductContainer = () => {
    const viewModel = this.getSingleProductViewModel();
    const {
      updateProduct,
      selectedStore,
      history,
      currency,
      loyalty,
      useFullscreenCarousel,
    } = this.props;

    if (!viewModel) {
      return (
        <div className={styles.pageLoaderWrapper}>
          <Loader />
        </div>
      );
    }

    const {
      product,
      quantity,
      updateCartLoading,
      productAddError,
      productPriceItem,
      totalCost,
      calories,
      points,
    } = viewModel;
    const addProductText = selectedStore
      ? productConstants.ADD_TO_ORDER_TEXT
      : productConstants.ADD_TO_ORDER_NO_ADDRESS_TEXT;
    const addUpdateProductText = updateProduct
      ? productConstants.UPDATE_PRODUCT_TEXT
      : addProductText;
    const outOfStockText = productConstants.OUT_OF_STOCK_TEXT;

    return (
      <div
        className={`${styles.productPageContainer} flex justify-between gap-8 md:p-0 px-4`}
      >
        <div className={styles.productImageContainer}>
          <img alt="" src={product.productImage} />
        </div>
        <div className={`${styles.productDetailsContainer}`}>
          <div className={`${styles.productHeader}`}>
            <div className={styles.backMenu}>
              <div
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    this.handleBackToMenu();
                  }
                }}
                className="w-full flex text-dark dark:text-white items-center gap-4 font-montserratMedium font-bold mb-4"
                onClick={this.handleBackToMenu}
              >
                <span>
                  <img
                    alt=""
                    src={backIcon}
                    className="block dark:hidden"
                  />
                  <img
                    alt=""
                    src={lightBackIcon}
                    className="hidden dark:block"
                  />
                </span>
                Back to Menu
              </div>
            </div>
            <h1 className="block md:hidden font-congenialRegular font-bold text-[44px] leading-[46px] tracking-[-1px] text-dark dark:text-white">
              {product.title}
            </h1>
            {loyalty ? (
              <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                {points}
                {' pts'}
                {renderLoyaltyPrice(this)}
              </span>
            ) : productPriceItem ? (
              <div className="flex items-center gap-2">
                {product.strike_price ? (
                  <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                    $
                    {currency.symbol}
                    <strike>{parseFloat(product.strike_price).toFixed(2)}</strike>
                    &nbsp;
                    {productPriceItem}
                  </span>
                ) : (
                  <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
                    {productPriceItem}
                  </span>
                )}
                <DiscountTag
                  discountPercent={product.discountPercent}
                />
              </div>
            ) : null}

            <h1 className=" hidden md:block font-congenialRegular font-bold text-[44px] leading-[46px] tracking-[-1px] text-dark dark:text-white">
              {product.metaHeading || product.title}
            </h1>
          </div>
          <p className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
            {product.description}
            {' '}
            <span className=" text-dark dark:text-white font-montserratMedium text-lg leading-[22px] tracking-[-0.1px] ">
              {calories}
            </span>
          </p>
          {/* QUANTITY SELECTOR */}
          <div className={styles.productQuantityContainer}>
            <div>
              {/* NUTRITIONAL INFORMATION */}
              <h2
                className={`${styles.nutritionalInfo} text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]`}
              >
                <a
                  href={
                    product.nutritionInfoLink
                      ? product.nutritionInfoLink
                      : endpoints.nutritionalInfo
                  }
                  target="blank"
                  className="text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]"
                >
                  Nutritional info
                </a>
              </h2>
              { product.oos === 1 ? null : (
                <p className="text-dark dark:text-white font-montserratBold text-lg leading-[22px] tracking-[-0.1px]">
                How many?
                </p>
              )}
              { product.oos === 1 ? null : (
                <p
                  onClick={() => this.setState({ quantity: 1 })}
                  className="text-[#983992] font-montserratBold text-lg leading-[22px] tracking-[-0.1px]"
                >
                Clear selections
                </p>
              )}
            </div>

            <div
              className={`${styles.productQuantityChooseContainer} ${
                loyalty || product.oos === 1 ? "hidden" : ""
              }`}
            >
              <div className="w-11 h-11 rounded-full bg-dark dark:bg-light flex items-center">
                <img
                  onClick={() => this.handleQuantityChange()}
                  alt=""
                  src={minusIcon}
                  className="block dark:hidden m-auto w-6 h-6"
                />
                <img
                  onClick={() => this.handleQuantityChange()}
                  alt=""
                  src={darkMinusIcon}
                  className="dark:block hidden m-auto w-6 h-6"
                />
              </div>
              <span className="text-dark dark:text-white font-montserratBold text-lg leading-[22px] tracking-[-0.1px] w-2 h-[22px]">
                {quantity}
              </span>
              <div className="w-11 h-11 rounded-full bg-dark dark:bg-light flex items-center">
                <img
                  onClick={() => this.handleQuantityChange(true)}
                  alt=""
                  src={addIcon}
                  className="block dark:hidden m-auto w-6 h-6"
                />
                <img
                  onClick={() => this.handleQuantityChange(true)}
                  alt=""
                  src={darkAddIcon}
                  className="dark:block hidden m-auto w-6 h-6"
                />
              </div>
            </div>
          </div>

          {/* ACTIONS CONTAINER */}
          <div className={styles.cartWrapper}>
            {updateCartLoading ? (
              <div className={styles.loaderWrapper}>
                <Loader />
              </div>
            ) : null}

            <CheckoutCartButton
              alertMessage=""
              label={product.oos === 1 ? outOfStockText : addUpdateProductText}
              onClick={() => {
                this.handleAddItem();
              }}
              isDisabled={product.oos === 1 || updateCartLoading}
              price={loyalty ? points : totalCost}
              loyalty={loyalty}
              boldLabel={useFullscreenCarousel}
            />

            {false && (
              <QuickCheckoutButton
                addProductToCart={this.handleQuickCheckout}
                setCartLoading={this.setCartLoading}
                isDisabled={product.oos === 1 || updateCartLoading}
                product={product}
                history={history}
              />
            )}
            {productAddError.length ? (
              <p className={styles.errorMessage}>{productAddError}</p>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (isBrandRefreshEnabled()) {
      return <this.brandRefreshContainer />;
    }
    return <this.singleProductContainer />;
  }
}

SingleProduct.propTypes = {
  isCaloriesActive: PropTypes.bool,
  isShowOosProducts: PropTypes.bool,
  currency: PropTypes.objectOf(PropTypes.string),
  useFullscreenCarousel: PropTypes.bool
};

SingleProduct.defaultProps = {
  isCaloriesActive: false,
  isShowOosProducts: false,
  currency: defaultCurrency,
  useFullscreenCarousel: isBrandRefreshEnabled()
};

export const mapDispatchToProps = dispatch => ({
  setUserCart: value => dispatch(userActions.setUserCart(value)),
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  setModalObject: value => dispatch(elementActions.setModalObject(value)),
  setStoreId: value => dispatch(userActions.setSelectedStore(value)),
  setUserOrderMethodId: value => dispatch(userActions.setUserOrderMethod(value))
});

export const mapStateToProps = state => {
  const {
    userCart,
    userCartId,
    userInfo,
    selectedStore,
    userOrderMethod
  } = state.user;
  const { designId } = state.customCakeTopper;
  const { isCaloriesActive, isShowOosProducts } = state.product;
  const { currency } = state.currency;
  const { loyaltyRedeemables, loyaltyDeals, loyaltyPoints, redeemables } = state.loyalty;
  const { order } = state;
  return {
    userCart,
    userCartId,
    userInfo,
    selectedStore,
    userOrderMethod,
    designId,
    isCaloriesActive,
    isShowOosProducts,
    currency,
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    order,
    redeemables
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SingleProduct)
);
